// components/RightSidebarFilter.js
import React from "react";
import Select from "react-select";
import DateRangeReport from "../DateRangeReport";

const RightSidebarFilter = ({
  isVisible,
  onClose,
  onDateChange,
  onStoreChange,
  storeList,
  range,
}) => {
  return (
    <div
      className={`position-fixed top-0 end-0 bg-white p-4 shadow h-100 zindex-tooltip transition ${
        isVisible ? "d-block" : "d-none"
      }`}
      style={{
        width: "80%",
        maxWidth: "300px",
        zIndex: 1050,
        overflowY: "auto",
      }}
    >
      <div
        className="d-flex justify-content-between align-items-center mb-3"
        style={{ color: "#83c14a" }}
      >
        <h5 className="mb-0">Filters</h5>
        <button className="btn-close" onClick={onClose}></button>
      </div>

      <DateRangeReport onChange={onDateChange} field="tran_date" />

      <div className="mt-3">
        <Select
          options={storeList?.map((code) => ({
            value: code.name,
            label: code.name.replace(/_/g, " "),
          }))}
          onChange={(selected) => onStoreChange(selected.value)}
          isDisabled={!range}
          placeholder="Select Store"
          className="basic-single"
          classNamePrefix="select"
        />
      </div>
    </div>
  );
};

export default RightSidebarFilter;
